export default "__VITE_ASSET__37SSe8Sb__"